import MALayout from '../../../Components/M&ALayout'
import Card from '../../../Components/MaAcquirers//AcqirerDetailTopCard'
import RefineSearch from '../../../Components/RE/RefineSearchComponent'
import AllAcquirersDetail from '../../../Components/MaAcquirers/AcquirerAllDetail'


function AllAcquirer() {
    return (
        <div>
            <MALayout>
                <div className="flex h-screen flex-col">
                    {/* <Card /> */}
                    <div className="mt-12 flex min-h-0 flex-1 overflow-hidden">
                        {/* Primary column */}
                        <section
                            aria-labelledby="primary-heading"
                            className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last">
                            <AllAcquirersDetail />

                            {/* <Outlet /> */}
                            {/* Your content */}
                        </section>
                        {/* Secondary column (hidden on smaller screens) */}
                        <aside className="hidden lg:order-first lg:block lg:flex-shrink-0">
                            <div className="relative flex h-full  flex-col overflow-y-auto border-r border-gray-200 bg-[#FAF5EA]">
                                {/* Your content */}
                                <RefineSearch />
                            </div>
                        </aside>
                    </div>                    
                </div>
            </MALayout>
        </div>
    )
}

export default AllAcquirer